import FormValidationUtils from "../utilities/FormValidationUtils";
import { FormSectionElements, FormSections } from "../entities/formTemplateDataType";
import { GlpResponseHandler } from "./GlpResponseHandler";
import { PlpResponseHandler } from "./PlpResponseHandler";
import { convertToTitleCase } from "../utilities/Utils";
import { EhocmPartnerIdResponseHandler } from "./EhocmPartnerIdResponseHandler";

const Handlers = {  // To define the list of handlers that extend AbstractReponseHandler.
   EhocmPartnerIdResponseHandler: EhocmPartnerIdResponseHandler,
   GlpResponseHandler: GlpResponseHandler,
   PlpResponseHandler: PlpResponseHandler
}

/**
 * Verify if <category-id+'ResponseHandler'> handler exists.
 * @param categoryId Category id of the application.
 */
export const hasHandler = (categoryId: string): boolean => {
  const handlerNameSuffix = 'ResponseHandler';
  const handlerName = convertToTitleCase(categoryId).concat(handlerNameSuffix);
  const handlerPrototype = Handlers[handlerName]?.prototype || {};
  return (Object.keys(handlerPrototype).length > 0 && typeof handlerPrototype.constructor === 'function');
}

/**
 * Lookup <category-id+'ResponseHandler'> handler, and execute its handle method.
 * @param categoryId Category id of the application.
 * @param response The service-call response to handle.
 * @param fieldOrSection FormSectionElements is for handling service-call response 
 * from component, and FormSections is for handling default Submit button. 
 */
export const handleResponse = (categoryId: string, response: any, fieldOrSection: FormSectionElements | FormSections = null, callbackValidate: any = null): any => {
  const handlerNameSuffix = 'ResponseHandler';
  const handlerName = convertToTitleCase(categoryId)?.concat(handlerNameSuffix);
  const HandlerClass = Handlers[handlerName];
  
  if (!HandlerClass || typeof HandlerClass !== 'function') {
    return null;
  }

  const handlerPrototype = HandlerClass.prototype || {};
  if (typeof handlerPrototype.handle !== 'function') {
    return null;
  }

  const handler = Object.create(handlerPrototype);
  if (handler) {
    handler.constructor.apply(handler);
    if (typeof handler.handle === 'function') {
      const result = handler.handle(response, fieldOrSection);
      if (result && !result.processSuccessful) {
        const invalidControlList = getInvalidControls(fieldOrSection instanceof FormSections ? fieldOrSection as FormSections : fieldOrSection.parent.parent);
        if (invalidControlList?.length > 0) {
          if (callbackValidate) {
            callbackValidate(invalidControlList);
          }
        }
      }
      return result;
    } else {
      console.log('handler ' + handlerName + ' handle method is not a function after instantiation');
      return null;
    }
  } else {
    console.log('handler ' + handlerName + ' could not be instantiated');
    return null;
  }
}

/**
 * Similar to the invalidControls method in FormValidationUtils, except that it doesn't invoke the form validation.
 */
export const getInvalidControls = (formSection: FormSections) => {
  let invalidList: FormSectionElements[] = [];
  let fieldList: FormSectionElements[] = [];

  formSection.ListOfFormSubSections.forEach((sub) => {
    sub.ListOfFormSectionElements.forEach(field=>{
      if (field.Visible && field.Datatype!='HiddenField'){
        if (field.Datatype!='Row') {
          fieldList.push(field)
        } else {
          field.subSectionList[0].ListOfFormSectionElements.forEach(field => {
            fieldList.push(field);
          })
        }
      }
    })
  })

  if (fieldList.length == 0) {
      return invalidList;
  }

  fieldList.forEach((field: FormSectionElements) => {
    if (!field.Valid) {
      invalidList.push(field);
    } else {
      FormValidationUtils.runJavascript(field);
      if (!field.Valid) {
        if (invalidList.filter(p => p.Id == field.Id).length == 0) {
          invalidList.push(field);
        }
      }
    }
  })
  console.log("invalidList in HandleResponseService", invalidList);
  return invalidList;
}
